import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ChevronDoubleUpIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/chevron-double-up"><g id="Icon"><path d="M11.3636 11.9135C11.7151 11.562 12.2849 11.562 12.6364 11.9135L16.1364 15.4135C16.4878 15.765 16.4878 16.3348 16.1364 16.6863C15.7849 17.0378 15.2151 17.0378 14.8636 16.6863L12 13.8227L9.13637 16.6863C8.7849 17.0378 8.21505 17.0378 7.86358 16.6863C7.51211 16.3348 7.51211 15.765 7.86358 15.4135L11.3636 11.9135Z" fill="currentColor" /><path d="M11.3636 6.91351C11.7151 6.56203 12.2849 6.56203 12.6364 6.91351L16.1364 10.4135C16.4878 10.765 16.4878 11.3348 16.1364 11.6863C15.7849 12.0378 15.2151 12.0378 14.8636 11.6863L12 8.82269L9.13637 11.6863C8.7849 12.0378 8.21505 12.0378 7.86358 11.6863C7.51211 11.3348 7.51211 10.765 7.86358 10.4135L11.3636 6.91351Z" fill="currentColor" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ChevronDoubleUpIcon;